(() => {

  const MENU_SELECTOR = '.huk_menu_app'; 
  const normalizeText = (str = '') =>
    String(str).replace(/\s+/g, ' ').trim();

  const slugify = (str = '') =>
    normalizeText(str)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, 'y')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const add = (el, cls) => {
    if (!el || !cls) return;
    el.classList.add(cls);
  };

  const getLabel = (node) => {
    // Busca span del texto del menú en el scope
    const el = node?.querySelector(
      ':scope > a .huk_menu_item_text,' +
      ':scope > .huk_menu_item_link .huk_menu_item_text,' +
      ':scope .huk_menu_item_text'
    );
    return normalizeText(el?.textContent || '');
  };

  const addToInnerBox = (li, cls) => {
    // Aplica también a un contenedor interno típico
    const inner =
      li.querySelector(':scope > a > .huk_menu_image') ||
      li.querySelector(':scope > a > .huk_menu_item_layout') ||
      li.querySelector(':scope > a > div') ||
      li.querySelector(':scope > .huk_menu_item_link > .huk_menu_image') ||
      li.querySelector(':scope > .huk_menu_item_link > div');
    if (inner) add(inner, cls);
  };

  // Desktop: asigna league-* a tabs y panel por índice
  const tagDesktopTabs = (rootLi, rootSlug) => {
    const submenu = rootLi.querySelector(':scope > .huk_menu_submenu');
    if (!submenu) return;

    const tabControl = submenu.querySelector('.huk_menu_submenu_tab_control');
    const tabContent = submenu.querySelector('.huk_menu_submenu_tab_content');
    if (!tabControl || !tabContent) return;

    const tabs = tabControl.querySelectorAll(':scope > li');
    const panels = tabContent.querySelectorAll(':scope > .huk_menu_submenu_tab_item');

    tabs.forEach((tabLi, idx) => {
      const label = getLabel(tabLi);
      if (!label) return;
      const leagueSlug = slugify(label);
      if (!leagueSlug) return;

      const leagueClass = `submenu-${leagueSlug}`;

      add(tabLi, leagueClass);
      add(tabLi, `dentro-menu-${rootSlug}`);
      addToInnerBox(tabLi, leagueClass);

      const panel = panels[idx];
      if (panel) {
        add(panel, leagueClass);
        add(panel, `dentro-menu-${rootSlug}`);

        // Todo lo que esté dentro del panel pertenece a esa liga
        panel.querySelectorAll('li').forEach(li => add(li, `dentro-${leagueClass}`));
      }
    });
  };

  // Mobile: detecta ligas como hijos directos del primer UL dentro del submenu del root
  const tagMobileLeagues = (rootLi, rootSlug) => {
    const submenu = rootLi.querySelector(':scope > .huk_menu_submenu');
    if (!submenu) return;

    // primer UL "real" dentro del submenu
    const firstUl =
      submenu.querySelector(':scope > ul') ||
      submenu.querySelector('ul');

    if (!firstUl) return;

    // hijos directos del primer UL (estos suelen ser MLB/NFL/NBA... en tu estructura móvil)
    const leagueLis = firstUl.querySelectorAll(':scope > li');

    leagueLis.forEach((leagueLi) => {
      const label = getLabel(leagueLi);
      if (!label) return;

      const leagueSlug = slugify(label);
      if (!leagueSlug) return;

      const leagueClass = `submenu-${leagueSlug}`;

      add(leagueLi, leagueClass);
      add(leagueLi, `dentro-menu-${rootSlug}`);
      addToInnerBox(leagueLi, leagueClass);

      // Descendientes dentro de esa liga
      leagueLi.querySelectorAll('li').forEach(li => add(li, `dentro-${leagueClass}`));
    });
  };

  const applyToMenu = (menuRoot) => {
    if (!menuRoot) return;

    // 1) Root items: li nivel 0 (si existe esa clase). Si no, fallback: primeros li directos del menuRoot
    const rootLis =
      menuRoot.querySelectorAll('li.huk_menu_item_level_0.huk_menu_item--root').length
        ? menuRoot.querySelectorAll('li.huk_menu_item_level_0.huk_menu_item--root')
        : menuRoot.querySelectorAll(':scope > li');

    rootLis.forEach((rootLi) => {
      const rootLabel = getLabel(rootLi);
      if (!rootLabel) return;

      const rootSlug = slugify(rootLabel);
      if (!rootSlug) return;

      const rootClass = `menu-${rootSlug}`;
      add(rootLi, rootClass);
      addToInnerBox(rootLi, rootClass);

      // Contexto: todo descendiente del root
      rootLi.querySelectorAll('li').forEach(li => add(li, `dentro-${rootClass}`));

      // Desktop tabs + Mobile leagues (si aplica)
      tagDesktopTabs(rootLi, rootSlug);
      tagMobileLeagues(rootLi, rootSlug);
    });

    // 2) Subitems genéricos: cualquier LI con texto (incluye los que NO tienen huk_menu_item)
    menuRoot.querySelectorAll('li').forEach((li) => {
      // Evita poner submenu-* al root (si ya tiene menu-*)
      if ([...li.classList].some(c => c.startsWith('menu-'))) return;

      const label = getLabel(li);
      if (!label) return;

      const slug = slugify(label);
      if (!slug) return;

      const cls = `submenu-${slug}`;
      add(li, cls);
      addToInnerBox(li, cls);
    });
  };

  const run = () => {
    // Aplica a todos los menús hukify que existan
    document.querySelectorAll(MENU_SELECTOR).forEach(applyToMenu);
  };

  // Ejecuta una vez
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Observa cambios: mobile drawer / re-render / expand
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
``